<script setup lang="ts">
import {computed, onBeforeMount, onMounted, onUnmounted} from "vue";
import {Synchronizer} from "@/synchronizer/service/Synchronizer";
import {useSettingsStore} from "@/core/stores/settings_store";
import {useRouter} from "vue-router";
import routes from "@/core/router/routes";

const synchronizer = new Synchronizer();
const router = useRouter();
let timer: number | null = null;
const settingsStore = useSettingsStore();
const companyLogo = computed(() => {
  if (!settingsStore.companyConfig.logo)
    return "";
  try {
    return require("@/assets/companies/" + settingsStore.companyConfig.logo);
  } catch (e) {
    console.error(e);
    return "";
  }
});

onBeforeMount(async () => {
  await settingsStore.init();
});

onMounted(() => {
  timer = setInterval(async () => {
    if (router.currentRoute.value.name != routes.send.name)
      await synchronizer.sync();
  }, 10_000);
});

onUnmounted(() => {
  if (timer)
    clearInterval(timer);
});
</script>

<template>
  <header>
    <div class="container-fluid">
      <div class="row d-flex justify-content-between">
        <div class="col-6 logo">
          <router-link to="/"><img src="@/assets/logo.jpg" alt="logo"></router-link>
        </div>
        <div class="col-6 logo-cliente"><img :src="companyLogo" alt="company logo"></div>
      </div>
    </div>
  </header>
  <main>
    <router-view/>
  </main>
</template>

<style lang="scss">
@import "@/scss/style.scss";
</style>
